import { Input } from "@/components/ui/input";
import { Search } from "lucide-react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { cn } from "@/lib/utils";

export function HeaderSearchBar({ className }: { className?: string }) {
  const [searchTerm, setSearchTerm] = useState("");
  const navigate = useNavigate();

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const trimmed = searchTerm.trim();
    if (trimmed) {
      navigate(`/sok?term=${encodeURIComponent(trimmed)}`);
    }
  };

  return (
    <form onSubmit={handleSubmit} className={cn("relative flex items-center", className)} role="search">
      <Search
        className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-gray-400 pointer-events-none"
        aria-hidden
      />
      <Input
        type="search"
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        placeholder="Sök"
        className="h-10 w-full min-w-[140px] max-w-[200px] lg:min-w-[160px] lg:max-w-[240px] xl:min-w-[200px] xl:max-w-[280px] pl-9 pr-3 rounded-lg border-gray-200 bg-white text-sm"
        aria-label="Sök"
      />
    </form>
  );
}
